import React from 'react';
import css from './ThreeLoadingDots.css';

const ThreeLoadingDots = () => {
    return (
        <span className={css.container}>
            <span>.</span>
            <span>.</span>
            <span>.</span>
        </span>
    );
};

export default ThreeLoadingDots;
